import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import { useViewLeadLogs } from "./use-view-lead-logs";
import { getOneLeadLogsQueryOptions } from "@/config/queries/query-options";
import { useMemo } from "react";
import { DataTable } from "./lead-logs-table/data-table";
import { getColumns } from "./lead-logs-table/columns";
import { LeadLog } from "./lead-logs-table/schema";
import { ColumnDef } from "@tanstack/react-table";

export const ViewLeadLogsModal = () => {
  const key = Cookies.get("key") as string;
  const { open, onOpenChange, setLeadId, leadId } = useViewLeadLogs();

  const { data, isPending, isFetching } = useQuery(
    getOneLeadLogsQueryOptions(key, leadId)
  );

  const leadLogs = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.logs === undefined) {
      return [];
    }

    const result = data?.logs?.map((log) => {
      return {
        id: log?._id,
        beforeStatus: log?.beforeStatus,
        afterStatus: log?.afterStatus,
        comments: log?.comments,
        createdAt: log?.createdAt as string | Date,
        ...(log?.createdBy
          ? {
              createdBy: log?.createdBy?.name,
            }
          : {}),
      };
    });

    return result?.sort((a, b) => {
      return (
        new Date(b?.createdAt as string).getTime() -
        new Date(a?.createdAt as string).getTime()
      );
    });
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<LeadLog, unknown>[]>(
    () => getColumns(),
    []
  );

  return (
    <>
      <Dialog
        open={open}
        onOpenChange={(open) => {
          onOpenChange(open);
          if (open === false) {
            setLeadId("");
          }
        }}
      >
        <DialogContent className="max-w-5xl">
          <DialogHeader>
            <DialogTitle className="tracking-normal">Lead Logs</DialogTitle>
          </DialogHeader>

          <div className="">
            <DataTable data={leadLogs} columns={columns} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
